import DeleteAddressNoteModal from './DeleteAddressNoteModal'

export default DeleteAddressNoteModal
